import React, {Component} from 'react';
import { connect } from 'react-redux';

import Loading from 'components/Loading';
import HeaderWalletCharge from 'components/walletcharge/HeaderWalletCharge';
import ContentWalletCharge from 'components/walletcharge/ContentWalletCharge';

import queryString from "query-string";

import 'sass/member/wallet/walletCharge.scss';

import { getMemberWalletCharge } from 'reducers/memberWalletCharge';

class WalletCharge extends Component {

    constructor(props) {
        super(props);

        this.state = { };
    }

    getSearchObject({location}) {
        let query = queryString.parse(location.search);

        if(!query.order_id) query.order_id = "order_id";
        if(!query.hash) query.hash = "hash";

        return query;
    }

    fetchData({dispatch, location, params}) {
        let query = this.getSearchObject({location});

        let reducerParams = {
            order_id: query.order_id,
            hash: query.hash,
            ...params
        };

        this.setState(reducerParams);

        return dispatch(getMemberWalletCharge(reducerParams));
    }

    componentDidMount() {
        let {dispatch, location} = this.props;

        this.fetchData({dispatch, location});
    }

    render() {
        if(!this.props.memberWalletCharge.data) return <Loading centered/>;

        const {
            hash,
            order_id
        } = this.state;

        const { memberWalletCharge } = this.props;

        return (
            <div id="wrapper">
                <HeaderWalletCharge />
                <ContentWalletCharge
                    hash={hash}
                    order_id={order_id}
                    memberWalletCharge={memberWalletCharge} 
                />
            </div>
        )
    }
}

export default connect(
    state => ({
        memberWalletCharge: state.memberWalletCharge
    }),
    null
)(WalletCharge)


// WEBPACK FOOTER //
// ./src/containers/member/WalletCharge.js